<template>
  <v-container fluid>
    <v-row v-for="categoria in categorias" :key="categoria.nome" class="mx-auto">
      <v-col cols="12">
        <h2>{{ categoria.nome }}</h2>
      </v-col>
      <template v-for="(item, _key) in categoria.items">
        <v-col v-if="item.admin" :key="_key" class="xs" sm="6" md="4" lg="3">
          <v-hover v-slot:default="{ hover }">
            <v-card
              :id="_key"
              class="d-flex mx-auto my-auto px-2"
              width="352px"
              height="100px"
              :color="hover ? 'grey lighten-2' : 'grey lighten-3'"
              elevation="1"
              :to="item.link"
            >
              <v-row no-gutters align="center" justify="center">
                <v-col cols="2">
                  <v-icon class="d-flex justify-center my-auto" :size="item.icon_size || 40" color="#E5502C">
                    {{ item.icone }}
                  </v-icon>
                </v-col>
                <v-col cols="10">
                  <v-card-text class="mx-auto my-auto">
                    <div class="subtitle-2" style="word-break: normal">
                      {{ item.nome }}
                    </div>
                    <div class="caption text--secondary">
                      {{ item.descricao }}
                    </div>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </v-hover>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    computed: {
      categorias() {
        let categorias = [
          {
            nome: '',
            items: this.paginas
          }
        ];
        return categorias;
      },
      paginas() {
        let paginas = [
          {
            nome: 'Usuários',
            link: '/administracao/usuarios',
            descricao: 'Gerencia usuários no sistema',
            icone: 'mdi-badge-account',
            admin: this.userIsAdmin || this.userIsManager
          },
          {
            nome: 'Perfis de Usuários',
            link: '/administracao/perfis',
            descricao: 'Gerencie os Perfis de Usuários do Hexa',
            icone: 'mdi-account-cog',
            admin: this.userIsAdmin
          },
          {
            nome: 'Empresas',
            link: '/administracao/empresas',
            descricao: 'Gerencia empresas no sistema',
            icone: 'mdi-office-building-outline',
            admin: this.userIsAdmin
          },
          {
            nome: 'Categorias',
            link: '/administracao/categorias',
            descricao: 'Gerencia categorias de power Ups',
            icone: 'mdi-label-multiple-outline',
            admin: this.userIsAdmin
          },
          {
            nome: 'Power Ups',
            link: '/administracao/powerups',
            descricao: 'Controle do menu de ferramentas',
            icone: 'mdi-lightning-bolt',
            admin: this.userIsAdmin
          },
          {
            nome: 'Logs da Aplicação',
            link: '/administracao/logs-aplicacao',
            descricao: 'Consulta os logs gerados pela aplicação',
            icone: 'mdi-alert-outline',
            admin: this.userIsAdmin
          },
          {
            nome: 'Tours',
            link: '/administracao/tour',
            descricao: 'Lista os tours de todas páginas do sistema',
            icone: 'mdi-help-circle',
            admin: this.userIsAdmin
          },
          {
            nome: 'Manutenção de Mapeamentos',
            link: '/manutencao-mapeamentos',
            descricao: 'Gerencia os mapeamentos',
            icone: 'mdi-file-cog',
            admin: this.userIsAdmin
          },
          {
            nome: 'Versionamento da BDGD',
            link: '/administracao/versionamento-bdgd',
            descricao: 'Gerencia as versões das BDGD importadas',
            icone: 'mdi-file-compare',
            admin: this.userIsAdmin
          },
          {
            nome: 'Outras Configurações',
            link: '/administracao/configuracoes',
            descricao: 'Gerencia algumas configurações básicas do Hexa',
            icone: 'mdi-cog',
            admin: this.userIsAdmin
          }
        ];

        if (process.env.NODE_ENV === 'development') {
          paginas.push({
            nome: 'Relatórios Modelos',
            link: '/administracao/relatorios-modelos/historico',
            descricao: 'Gerencia seus grupos e templates de relatórios modelos',
            icone: 'mdi-file-settings',
            admin: this.userIsAdmin
          });
        }

        paginas.sort((a, b) => a.nome.localeCompare(b.nome));

        return paginas;
      },
      userIsAdmin() {
        return this.$store.getters.userIsAdmin;
      },
      userIsManager() {
        return this.$store.getters.getUserIsManager;
      }
    }
  };
</script>
